// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__bCNMc","productName":"Table_productName__3VTtm"};